// extracted by mini-css-extract-plugin
export var container = "Chip-module--container--7f167";
export var green = "Chip-module--green--bd52d";
export var group = "Chip-module--group--ac3a1";
export var red = "Chip-module--red--c7c8c";
export var yellow = "Chip-module--yellow--1f53f";